import type { FC } from 'react';
import { UserSearchForm } from './UserSearchForm';
import { UsersTable } from './UsersTable';

export const UsersPage: FC = () => {
  return (
    <>
      <UserSearchForm />
      <UsersTable />
    </>
  );
};
